module.exports = __webpack_public_path__ + "static/media/Luis_Campbell.a2a0591b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/leadership/Luis_Campbell.jpg
// module id = 294
// module chunks = 0